import { Skeleton } from "../ui/skeleton";

export default function BuySellPageSkeleton() {
  return (
    <div className="flex flex-col w-full p-8 shadow-lg bg-white rounded-2xl">
      {/* Tabs Skeleton */}
      <div className="mb-8">
        <div className="grid grid-cols-2 rounded-full h-full bg-white border border-neutral p-1 gap-2">
          <Skeleton className="h-12 rounded-full bg-gray-300" />
          <Skeleton className="h-12 rounded-full bg-gray-300" />
        </div>
      </div>

      {/* Asset Selector Section */}
      <div className="space-y-6 mb-6">
        {/* You Send/Receive Section */}
        <div className="space-y-2">
          {/* Label */}
          <Skeleton className="h-4 w-24 bg-gray-300" />

          {/* Asset Selection Card */}
          <div className="flex items-center justify-between border border-gray-200 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
              <Skeleton className="h-6 w-20 rounded-lg bg-gray-300" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
            </div>
          </div>

          {/* Pay with section */}
          <div className="flex items-center gap-6">
            <Skeleton className="h-4 w-24 bg-gray-300 mt-4" />
            <Skeleton className="h-4 w-24 bg-gray-300 mt-4 ml-16" />
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center border border-gray-200 rounded-lg p-4 w-1/4">
              <div className="flex items-center gap-3">
                <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
                <Skeleton className="h-6 w-20 rounded-lg bg-gray-300" />
              </div>
            </div>
            <div className="flex items-center border border-gray-200 rounded-lg p-4 w-full">
              <div className="flex items-center gap-3">
                <Skeleton className="h-8 w-20 rounded-lg bg-gray-300" />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-24 bg-gray-300 mt-4" />
          </div>

          {/* Enter Amount Section */}
          <div className="flex items-center justify-between border border-gray-200 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-20 rounded-lg bg-gray-300" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-6 w-16 rounded-full bg-gray-300" />
              <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
              <Skeleton className="h-10 w-20 rounded-full bg-gray-300" />
            </div>
          </div>
        </div>
      </div>

      {/* Create buy/sell order section */}
      <div className="space-y-4 py-4">
        <Skeleton className="h-10 w-36 mx-auto rounded-full bg-gray-300" />
      </div>

      {/* Continue Button */}
      <div className="flex justify-center pt-4">
        <Skeleton className="h-12 w-[300px] rounded-lg bg-gray-300" />
      </div>
    </div>
  );
}
